import React from 'react';
import { Sheet } from '../../../../mobile/structural/sheet';
import { useBoardLinkContent } from './useBoardLinkContent';
import BoardLinkSearchBar from './BoardLinkSearchBar';
import BoardLinkList from './BoardLinkList';

const BoardLinkSheetContent: React.FC = () => {
    const { searchQuery, setSearchQuery, gridSize, filteredBoards, handleBoardSelect } = useBoardLinkContent();

    return (
        <div className="px-3.5">
            <BoardLinkSearchBar
                className="mb-2 pt-0"
                query={searchQuery}
                onQueryChange={setSearchQuery}
                autoFocus={false}
                size="lg"
            />
            <Sheet.Content className="px-0">
                <BoardLinkList
                    boards={filteredBoards}
                    gridSize={gridSize}
                    onSelect={handleBoardSelect}
                    isSheet
                    size="lg"
                />
            </Sheet.Content>
        </div>
    );
};

export default BoardLinkSheetContent;
